import { jsx as _jsx } from "react/jsx-runtime";
import Carousel from "../../components/Carousel";
import { BannerSliderWrap, SliderImage } from "./style";
const apiUrl = process.env.PORTAL_URL || "http://localhost:7004";
export const BannerSlider = ({ banners }) => {
    return (_jsx(BannerSliderWrap, { children: _jsx(Carousel, Object.assign({ slidesToShow: 1, slidesToScroll: 1, arrows: false, autoplay: true, speed: 5000 }, { children: banners === null || banners === void 0 ? void 0 : banners.map((banner, index) => {
                return (_jsx("div", { children: _jsx(SliderImage, { children: _jsx("img", { src: `${apiUrl}/api/doacao-sangue/assets/${banner.directus_files_id}`, alt: banner.directus_files_id }) }) }, index));
            }) })) }));
};
